/* eslint-disable no-loss-of-precision */
import blank from '../Blank/blankData'

import Glasses01 from '../Glasses/Glasses01'
import Glasses02 from '../Glasses/Glasses02'
import Glasses03 from '../Glasses/Glasses03'
import Glasses04 from '../Glasses/Glasses04'
import Glasses05 from '../Glasses/Glasses05'
import Glasses06 from '../Glasses/Glasses06'
import Glasses07 from '../Glasses/Glasses07'
import Glasses08 from '../Glasses/Glasses08'
import Glasses09 from '../Glasses/Glasses09'
import Glasses10 from '../Glasses/Glasses10'
import Glasses11 from '../Glasses/Glasses11'
import Glasses16 from '../Glasses/Glasses16'
import Glasses21 from '../Glasses/Glasses21'
import Glasses26 from '../Glasses/Glasses26'
import Glasses12 from '../Glasses/Glasses12'
import Glasses17 from '../Glasses/Glasses17'
import Glasses22 from '../Glasses/Glasses22'
import Glasses27 from '../Glasses/Glasses27'
import Glasses13 from '../Glasses/Glasses13'
import Glasses18 from '../Glasses/Glasses18'
import Glasses23 from '../Glasses/Glasses23'
import Glasses14 from '../Glasses/Glasses14'
import Glasses19 from '../Glasses/Glasses19'
import Glasses24 from '../Glasses/Glasses24'
import Glasses15 from '../Glasses/Glasses15'
import Glasses20 from '../Glasses/Glasses20'
import Glasses25 from '../Glasses/Glasses25'

const data = [
  blank,
  {
    id: 'Glasses01',
    svg: Glasses01,
    positioning: {
      pointNarrow: {
        y: 95,
        scaleX: 1,
      },
      pointMedium: {
        y: 97.07406616210938,
        scaleX: 1,
      },
      pointWide: {
        y: 93.45712280273438,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 98.61630249023438,
        scaleX: 1,
      },
      roundMedium: {
        y: 98.27647399902344,
        scaleX: 1.1,
      },
      roundWide: {
        y: 96.77207946777344,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 96.69294738769531,
        scaleX: 1,
      },
      squareMedium: {
        y: 94.39558410644531,
        scaleX: 1.1,
      },
      squareWide: {
        y: 94.59561157226562,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses06',
    svg: Glasses06,
    positioning: {
      pointNarrow: {
        y: 94.93777465820312,
        scaleX: 1,
      },
      pointMedium: {
        y: 96.93479919433594,
        scaleX: 1,
      },
      pointWide: {
        y: 94.48921203613281,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 98.94595336914062,
        scaleX: 1,
      },
      roundMedium: {
        y: 97.70529174804688,
        scaleX: 1.05,
      },
      roundWide: {
        y: 96.44320678710938,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 95.99732971191406,
        scaleX: 1,
      },
      squareMedium: {
        y: 95,
        scaleX: 1,
      },
      squareWide: {
        y: 95.59309387207031,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses11',
    svg: Glasses11,
    positioning: {
      pointNarrow: {
        y: 96.01004028320312,
        scaleX: 1,
      },
      pointMedium: {
        y: 97.71749877929688,
        scaleX: 1,
      },
      pointWide: {
        y: 95.07444763183594,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 99.6754150390625,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 99.15400695800781,
        scaleX: 1,
      },
      roundWide: {
        y: 98.00286865234375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 95.85826110839844,
        scaleX: 1,
      },
      squareMedium: {
        y: 95.638916015625,
        scaleX: 1,
      },
      squareWide: {
        y: 95,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Glasses16',
    svg: Glasses16,
    positioning: {
      pointNarrow: {
        y: 94.12924194335938,
        scaleX: 1,
      },
      pointMedium: {
        y: 96.85871887207031,
        scaleX: 1,
      },
      pointWide: {
        y: 92.82289123535156,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 97.59541320800781,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 97.38230895996094,
        scaleX: 1,
      },
      roundWide: {
        y: 96.20217895507812,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 96.10768127441406,
        scaleX: 1,
      },
      squareMedium: {
        y: 94.74935913085938,
        scaleX: 1,
      },
      squareWide: {
        y: 95,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Glasses21',
    svg: Glasses21,
    positioning: {
      pointNarrow: {
        y: 97.74867248535156,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 99.13864135742188,
        scaleX: 1,
      },
      pointWide: {
        y: 96.27029418945312,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 101.9351806640625,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 100.18702697753906,
        scaleX: 1,
      },
      roundWide: {
        y: 99.93170166015625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 98.89578247070312,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.11903381347656,
        scaleX: 1,
      },
      squareWide: {
        y: 97.21717834472656,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Glasses26',
    svg: Glasses26,
    positioning: {
      pointNarrow: {
        y: 96.88369750976562,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.27287292480469,
        scaleX: 1,
      },
      pointWide: {
        y: 95.93656921386719,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 101.20475769042969,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 101.07583618164062,
        scaleX: 1.05,
      },
      roundWide: {
        y: 99.02015686035156,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 98.43217468261719,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.87028503417969,
        scaleX: 1,
      },
      squareWide: {
        y: 97.03120422363281,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Glasses02',
    svg: Glasses02,
    positioning: {
      pointNarrow: {
        y: 97.37786865234375,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.77548217773438,
        scaleX: 1,
      },
      pointWide: {
        y: 95.92024230957031,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 101.22793579101562,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 101.95968627929688,
        scaleX: 1.1,
      },
      roundWide: {
        y: 99.91055297851562,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 99.8052978515625,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.69454956054688,
        scaleX: 1.05,
      },
      squareWide: {
        y: 97.50186157226562,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Glasses07',
    svg: Glasses07,
    positioning: {
      pointNarrow: {
        y: 97.3428955078125,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.45790100097656,
        scaleX: 1,
      },
      pointWide: {
        y: 95.32125854492188,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 99.92193603515625,
        scaleX: 1,
      },
      roundMedium: {
        y: 99.83720397949219,
        scaleX: 1.05,
      },
      roundWide: {
        y: 98.11721801757812,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 97.17234802246094,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.88543701171875,
        scaleX: 1.1,
      },
      squareWide: {
        y: 97.21104431152344,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Glasses12',
    svg: Glasses12,
    positioning: {
      pointNarrow: {
        y: 96.10136413574219,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.93975830078125,
        scaleX: 1,
      },
      pointWide: {
        y: 95,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 99.59053039550781,
        scaleX: 1,
      },
      roundMedium: {
        y: 99.85064697265625,
        scaleX: 1,
      },
      roundWide: {
        y: 98.71440124511719,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 97.41384887695312,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.24429321289062,
        scaleX: 1,
      },
      squareWide: {
        y: 96.4886474609375,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses17',
    svg: Glasses17,
    positioning: {
      pointNarrow: {
        y: 96.64794921875,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.62007141113281,
        scaleX: 1,
      },
      pointWide: {
        y: 96.45819091796875,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.22390747070312,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.24110412597656,
        scaleX: 1,
      },
      roundWide: {
        y: 99.03514099121094,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 99.10784912109375,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.35810852050781,
        scaleX: 1,
      },
      squareWide: {
        y: 96.18679809570312,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses22',
    svg: Glasses22,
    positioning: {
      pointNarrow: {
        y: 97.05937194824219,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.16447448730469,
        scaleX: 1,
      },
      pointWide: {
        y: 95.76020812988281,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 99.0721435546875,
        scaleX: 1,
      },
      roundMedium: {
        y: 98.54864501953125,
        scaleX: 1,
      },
      roundWide: {
        y: 97.4664306640625,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 97.99105834960938,
        scaleX: 1,
      },
      squareMedium: {
        y: 95.75347900390625,
        scaleX: 1,
      },
      squareWide: {
        y: 96.21200561523438,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses27',
    svg: Glasses27,
    positioning: {
      pointNarrow: {
        y: 96.95277404785156,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.42915344238281,
        scaleX: 1,
      },
      pointWide: {
        y: 95.82777404785156,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 99.96978759765625,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 100.54359436035156,
        scaleX: 1,
      },
      roundWide: {
        y: 98.96005249023438,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 98.83990478515625,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.46937561035156,
        scaleX: 1,
      },
      squareWide: {
        y: 96.5513916015625,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses03',
    svg: Glasses03,
    positioning: {
      pointNarrow: {
        y: 96.91203308105469,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.25534057617188,
        scaleX: 1,
      },
      pointWide: {
        y: 95.75979614257812,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.68705749511719,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.03103637695312,
        scaleX: 1.1,
      },
      roundWide: {
        y: 99.05343627929688,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 99.03790283203125,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.94827270507812,
        scaleX: 1.05,
      },
      squareWide: {
        y: 97.68115234375,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses08',
    svg: Glasses08,
    positioning: {
      pointNarrow: {
        y: 96.46006774902344,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.50448608398438,
        scaleX: 1,
      },
      pointWide: {
        y: 95.89529418945312,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.17723083496094,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 99.70657348632812,
        scaleX: 1.05,
      },
      roundWide: {
        y: 98.17918395996094,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 97.48658752441406,
        scaleX: 1,
      },
      squareMedium: {
        y: 95.16152954101562,
        scaleX: 1.05,
      },
      squareWide: {
        y: 96.43299865722656,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses13',
    svg: Glasses13,
    positioning: {
      pointNarrow: {
        y: 95.75897216796875,
        scaleX: 1,
      },
      pointMedium: {
        y: 97.65080261230469,
        scaleX: 1,
      },
      pointWide: {
        y: 95,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.01666259765625,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 100.25138854980469,
        scaleX: 1.05,
      },
      roundWide: {
        y: 97.90237426757812,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 97.89987182617188,
        scaleX: 1,
      },
      squareMedium: {
        y: 95,
        scaleX: 1.05,
      },
      squareWide: {
        y: 95.65335083007812,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses18',
    svg: Glasses18,
    positioning: {
      pointNarrow: {
        y: 97.947509765625,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.868896484375,
        scaleX: 1,
      },
      pointWide: {
        y: 97.01905822753906,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 101.96409606933594,
        scaleX: 1,
      },
      roundMedium: {
        y: 101.64337158203125,
        scaleX: 1,
      },
      roundWide: {
        y: 98.59664916992188,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.98939514160156,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.65663146972656,
        scaleX: 1.1,
      },
      squareWide: {
        y: 97.64666748046875,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses23',
    svg: Glasses23,
    positioning: {
      pointNarrow: {
        y: 98.05323791503906,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.6544189453125,
        scaleX: 1,
      },
      pointWide: {
        y: 96.47093200683594,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.277099609375,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.94549560546875,
        scaleX: 1,
      },
      roundWide: {
        y: 98.64454650878906,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.41114807128906,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.156005859375,
        scaleX: 1,
      },
      squareWide: {
        y: 96.503662109375,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses04',
    svg: Glasses04,
    positioning: {
      pointNarrow: {
        y: 99.32864379882812,
        scaleX: 1,
      },
      pointMedium: {
        y: 101.38307189941406,
        scaleX: 1,
      },
      pointWide: {
        y: 99.28056335449219,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 103.97247314453125,
        scaleX: 1,
      },
      roundMedium: {
        y: 102.97810363769531,
        scaleX: 1.05,
      },
      roundWide: {
        y: 102.57499694824219,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 100.81486511230469,
        scaleX: 1,
      },
      squareMedium: {
        y: 99.76380920410156,
        scaleX: 1.1,
      },
      squareWide: {
        y: 99.23513793945312,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses09',
    svg: Glasses09,
    positioning: {
      pointNarrow: {
        y: 97.18466186523438,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.37030029296875,
        scaleX: 1,
      },
      pointWide: {
        y: 95.9720458984375,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.72352600097656,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.05107116699219,
        scaleX: 1.05,
      },
      roundWide: {
        y: 98.93002319335938,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 99.25039672851562,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.59930419921875,
        scaleX: 1.1,
      },
      squareWide: {
        y: 97.14849853515625,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses14',
    svg: Glasses14,
    positioning: {
      pointNarrow: {
        y: 97.1656494140625,
        scaleX: 1,
      },
      pointMedium: {
        y: 101.07240295410156,
        scaleX: 1,
      },
      pointWide: {
        y: 95,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 101.56825256347656,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.19578552246094,
        scaleX: 1.05,
      },
      roundWide: {
        y: 100.04278564453125,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.56094360351562,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.2939453125,
        scaleX: 1.05,
      },
      squareWide: {
        y: 96.76998901367188,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses19',
    svg: Glasses19,
    positioning: {
      pointNarrow: {
        y: 95.42523193359375,
        scaleX: 1.05,
      },
      pointMedium: {
        y: 100.66204833984375,
        scaleX: 1,
      },
      pointWide: {
        y: 95.87501525878906,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.01336669921875,
        scaleX: 1,
      },
      roundMedium: {
        y: 99.51803588867188,
        scaleX: 1.05,
      },
      roundWide: {
        y: 98.38468933105469,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 97.3819580078125,
        scaleX: 1,
      },
      squareMedium: {
        y: 95.9661865234375,
        scaleX: 1.05,
      },
      squareWide: {
        y: 95.513671875,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses24',
    svg: Glasses24,
    positioning: {
      pointNarrow: {
        y: 96.79731750488281,
        scaleX: 1,
      },
      pointMedium: {
        y: 100.41928100585938,
        scaleX: 1,
      },
      pointWide: {
        y: 96.7593994140625,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.27960205078125,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.29278564453125,
        scaleX: 1.05,
      },
      roundWide: {
        y: 99.44392395019531,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.06365966796875,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.23379516601562,
        scaleX: 1.05,
      },
      squareWide: {
        y: 96.29145812988281,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses05',
    svg: Glasses05,
    positioning: {
      pointNarrow: {
        y: 96.23342895507812,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.79400634765625,
        scaleX: 1,
      },
      pointWide: {
        y: 95.90374755859375,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.84295654296875,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.33609008789062,
        scaleX: 1.05,
      },
      roundWide: {
        y: 98.90264892578125,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 99.10218811035156,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.52484130859375,
        scaleX: 1.05,
      },
      squareWide: {
        y: 97.91258239746094,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses10',
    svg: Glasses10,
    positioning: {
      pointNarrow: {
        y: 96.37846374511719,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.86705017089844,
        scaleX: 1,
      },
      pointWide: {
        y: 95.32679748535156,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 98.97854614257812,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.04447937011719,
        scaleX: 1.05,
      },
      roundWide: {
        y: 99.75935363769531,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.74111938476562,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.51956176757812,
        scaleX: 1.1,
      },
      squareWide: {
        y: 96.70404052734375,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses15',
    svg: Glasses15,
    positioning: {
      pointNarrow: {
        y: 96.20390319824219,
        scaleX: 1,
      },
      pointMedium: {
        y: 100.1197509765625,
        scaleX: 1,
      },
      pointWide: {
        y: 96.93753051757812,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 101.5009765625,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.72578430175781,
        scaleX: 1.05,
      },
      roundWide: {
        y: 100.77005004882812,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.51019287109375,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.5909423828125,
        scaleX: 1,
      },
      squareWide: {
        y: 97.88761901855469,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses20',
    svg: Glasses20,
    positioning: {
      pointNarrow: {
        y: 97.17481994628906,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.86720275878906,
        scaleX: 1,
      },
      pointWide: {
        y: 97.28663635253906,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.49072265625,
        scaleX: 1,
      },
      roundMedium: {
        y: 99.93408203125,
        scaleX: 1.05,
      },
      roundWide: {
        y: 99.24456787109375,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 98.40682983398438,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.68864440917969,
        scaleX: 1,
      },
      squareWide: {
        y: 97.18785095214844,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Glasses25',
    svg: Glasses25,
    positioning: {
      pointNarrow: {
        y: 96.14004516601562,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 97.73204040527344,
        scaleX: 1,
      },
      pointWide: {
        y: 96.59547424316406,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 100.37452697753906,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 99.3067626953125,
        scaleX: 1.05,
      },
      roundWide: {
        y: 98.4776611328125,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 96.41633605957031,
        scaleX: 1,
      },
      squareMedium: {
        y: 96.79496765136719,
        scaleX: 1,
      },
      squareWide: {
        y: 96.82110595703125,
        scaleX: 1.15,
      },
    },
  },
]

export default data
